export const ATTRIBUTION_COOKIE_KEY = 'cm_attribution';

export const ATTRIBUTION_COOKIE_MAX_AGE_SECONDS: number = 60 * 60 * 24 * 180;
